import React, { useEffect } from 'react'

const LandingPage: React.FunctionComponent = () => {
  useEffect(() => {
    window.location.href = 'https://www.coop.se/bank-och-betalkort/inkopstjanst/'
  }, [])

  return null
}

export default LandingPage